export default {

  namespaced: true,

  state: {

    visited: false,
    interacted: false,

    desiresInlay: true,

    options: {
      sound: {
        label: "Sound",
        value: true,
        icons: {
          true  : 'volume',
          false : 'mute'
        }
      },
      showEverything: {
        label: "Reveal Everything",
        value: false,
        icons: {
          true  : 'show',
          false : 'hide'
        }
      },
      cleanCaptions: {
        label: "Easier Captions",
        value: false,
        icons: {
          true  : 'cc',
          false : 'cc'
        },
      },
      // highContrast: {
      //   label: "Higher Contrast",
      //   value: true,
      //   icons: {
      //     true  : 'contrast',
      //     false : 'contrast'
      //   }
      // },
      fontSize: {
        label: "Font Size",
        value: 1,
        icons: {
          true  : 'font',
          false : 'font'
        }
      },
    },
  },

  mutations: {

    setInteracted: state  => {
      state.interacted = true
    },

    toggleInlay: (state, desiresInlay) => {
      state.desiresInlay = desiresInlay
    },

    setOption: (state, { key, value }) => {
      state.options[key].value = value
    },

    setOptions: (state, options) => {
      state.options = options
    },

  },

  actions: {

    loadOptionsFromStore: ({ commit }) => {
      const found = localStorage.accessOptions && JSON.parse(localStorage.accessOptions)
      if (found) {
        if ( found.highContrast ) {
          delete found.highContrast
        }
        commit('setOptions', found)
      }
    },

    saveOptionsToStore: ({ state }) => {
      localStorage.accessOptions = JSON.stringify( state.options )
    },

    setOption: ({ commit, dispatch }, { key, value }) => {
      commit('setOption', { key, value })
      dispatch('saveOptionsToStore')
    }

  }

}
